"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trackify = void 0;
const tslib_1 = require("tslib");
const drivers_1 = require("./drivers");
const trackify_queue_1 = require("./helpers/trackify-queue");
class Trackify {
    constructor() {
        this.GLOBALS = {
            affiliation: null,
            currency: null,
            brand: null,
            language: null
        };
        this.drivers = new Map();
        this.driversResolved = false;
        this.registeredDrivers = new Set();
        this.queue = new Trackify.QUEUE_DRIVER();
        this.init();
    }
    track(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!event) {
                return;
            }
            event.setGlobals(this.GLOBALS);
            this.queue.push(event);
        });
    }
    useDriver(driver, config) {
        this.registeredDrivers.add([driver, config]);
    }
    useDrivers(drivers) {
        for (const [driver, config] of drivers) {
            this.useDriver(driver, config);
        }
    }
    loadDrivers() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.driversResolved) {
                return;
            }
            this.reportDebug('[Trackify drivers:]');
            this.reportDebug(this.registeredDrivers);
            for (const [token, config] of this.registeredDrivers) {
                try {
                    const driverConstructor = yield this.loadDriver(token);
                    const driver = new driverConstructor(config || {});
                    const driverLoaded = yield driver.load();
                    this.reportDebug('[Trackify] Driver load:' + driver.constructor.name);
                    if (driverLoaded) {
                        this.drivers.set(token, driver);
                    }
                }
                catch (error) {
                    this.reportError(error);
                }
            }
            yield this.afterDriversResolved();
        });
    }
    afterDriversResolved() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.driversResolved = true;
            this.queue.run();
        });
    }
    init() {
        this.queue.onProcessed((event) => {
            this.drivers.forEach((driver) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (driver.supportsEvent(event)) {
                    try {
                        console.debug('[Trackify.track]: ' + driver.name);
                        yield driver.track(event);
                    }
                    catch (error) {
                        this.reportError(error);
                    }
                }
            }));
        });
    }
    loadDriver(token) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const driverImport = drivers_1.analyticsDrivers.get(token);
            if (typeof driverImport === 'undefined') {
                throw new Error(`[Trackify] Driver ${Symbol.keyFor(token)} not found.`);
            }
            return yield driverImport();
        });
    }
    reportError(error) {
        if (typeof console !== 'undefined' && console.error) {
            console.error(error);
        }
    }
    reportDebug(log) {
        if (typeof console !== 'undefined' && console.debug) {
            console.debug(log);
        }
    }
}
exports.Trackify = Trackify;
Trackify.QUEUE_DRIVER = trackify_queue_1.TrackifyQueue;
//# sourceMappingURL=trackify.js.map